import React from "react";
import classnames from "classnames";
import { useSelector } from "react-redux";

import { Dispensary } from "custom-types/Dispensary";
import {
  getCurrentDispensary,
  getDispensaryScheduleStatuses,
} from "redux/selectors/dispensary";

type OpenStatusDispensaryProps = {
  className?: string;
  dispensary?: Dispensary | null;
};

export const OpenStatusDispensary: React.FC<OpenStatusDispensaryProps> = ({
  className,
}) => {
  const { storeStatusMessage } = useSelector(getDispensaryScheduleStatuses);

  return (
    <div className={classnames("text-xs", className)}>
      <span data-testid="statusMessage" className="mr-xs">
        {storeStatusMessage}
      </span>
    </div>
  );
};

const OpenStatus = ({ className }: { className?: string }) => {
  const dispensary = useSelector(getCurrentDispensary);
  return <OpenStatusDispensary className={className} dispensary={dispensary} />;
};

export default OpenStatus;
